
export enum IToasterVariant {
    Success = "success",
    Info = "information",
    Warning = "warning",
    Error = "error"
}

export interface IToasterInput {
    toasterVariant: IToasterVariant,
    toasterTimeoutMs: number,
    toasterHeader:string
    toasterMessage:string
}

export interface IPaginatorChange {
    currentPageNo: number;
    listId: string; 
}

export interface IPaginatorPage {
    currentPage: number;
    totalPages: number;
    rowsPerPage: number;
    paginatorIdentifier: string;
}
